import popupUtil from '@/commons/popupUtil';
import {computed} from 'vue';
import {ModuleOfflineWork} from '@/stores/moduleConst';
import indexedDB from '@/commons/indexedDB';
import _ from 'lodash';
import { ModuleBankInfo } from '@/stores/moduleConst';
export const useCopyNewVoucher = (proxy, detailGrid) => {
  const offlineReady = computed(() => {
    if (!proxy.$store.state[ModuleOfflineWork]) {
      return false;
    } else {
      return proxy.$store.state[ModuleOfflineWork].offlineReady;
    }
  });
  /**
   * Xử lý từng chứng từ
   * @param {*} data
   * @param {*} item
   */
  const customVoucherData = (data, item) => {
    // BUPlanWithdrawDeposit: 562, // Rút dự toán tiền gửi
    // BUPlanWithdrawCash: 54, // Rút dự toán tiền mặt
    // BUPlanWithdrawTransfer: 55, // Rút dự toán chuyển khoản

    // sao chép từ thu tiền gửi hoặc sao chép đên thu tiền gửi
    if (
      (item.refType == proxy.$ms.constant.RefType.BADeposit) ^
      (proxy.refType == proxy.$ms.constant.RefType.BADeposit)
    ) {
      [data.bank_account, data.accounting_object_bank_account] = [
        data.accounting_object_bank_account,
        data.bank_account,
      ];
      [data.bank_name, data.accounting_object_bank_name] = [data.accounting_object_bank_name, data.bank_name];
    }

    // Từ chi tiền gửi sang thu tiền gửi
    if (
      proxy.refType == proxy.$ms.constant.RefType.BAWithDraw &&
      item.refType == proxy.$ms.constant.RefType.BADeposit
    ) {
      delete data.accounting_object_code;
      delete data.accounting_object_name;
      delete data.accounting_object_address;
      delete data.bank_account;
      delete data.bank_name;
    }

    // Từ CKKB sang Chi tiền gửi
    if (
      proxy.refType == proxy.$ms.constant.RefType.BUTransfer &&
      item.refType == proxy.$ms.constant.RefType.BAWithDraw
    ) {
      data.bank_account = data.bank_info_code;
      data.bank_name = data.bank_info_name;
    }
    // Từ Chi tiền gửi sang CKKB
    if (
      proxy.refType == proxy.$ms.constant.RefType.BAWithDraw &&
      item.refType == proxy.$ms.constant.RefType.BUTransfer
    ) {
      data.bank_info_code = data.bank_account;
      data.bank_info_name = data.bank_name;
    }
    // Từ Thu tiền gửi sang CKKB
    if (
      proxy.refType == proxy.$ms.constant.RefType.BADeposit &&
      item.refType == proxy.$ms.constant.RefType.BUTransfer
    ) {
      delete data.accounting_object_id;
      delete data.accounting_object_code;
      delete data.accounting_object_name;
      delete data.accounting_object_bank_account;
      delete data.accounting_object_bank_name;
    }
    // Từ Thu tiền gửi sang Phiếu chi
    if (proxy.refType == proxy.$ms.constant.RefType.BADeposit && item.refType == proxy.$ms.constant.RefType.CAPayment) {
      delete data.accounting_object_id;
      delete data.accounting_object_code;
      delete data.accounting_object_name;
      delete data.accounting_object_address;
    }
    // Từ Chi tiền gửi sang Phiếu chi
    if (
      proxy.refType == proxy.$ms.constant.RefType.BAWithDraw &&
      item.refType == proxy.$ms.constant.RefType.CAPayment
    ) {
      delete data.accounting_object_id;
      delete data.accounting_object_code;
      delete data.accounting_object_name;
      delete data.accounting_object_address;
    }
    // Từ Chi tiền gửi sang Phiếu thu
    if (
      proxy.refType == proxy.$ms.constant.RefType.BAWithDraw &&
      item.refType == proxy.$ms.constant.RefType.CAReceipt
    ) {
      delete data.accounting_object_id;
      delete data.accounting_object_code;
      delete data.accounting_object_name;
      delete data.accounting_object_address;
    }
    // Từ CKKB sang Thu tiền gửi
    if (
      proxy.refType == proxy.$ms.constant.RefType.BUTransfer &&
      item.refType == proxy.$ms.constant.RefType.BADeposit
    ) {
      delete data.accounting_object_id;
      delete data.accounting_object_code;
      delete data.accounting_object_name;
      delete data.accounting_object_address;
      delete data.bank_account;
      delete data.bank_name;
    }
    // Từ Phiếu thu sang Chi tiền gửi
    if (
      proxy.refType == proxy.$ms.constant.RefType.CAReceipt &&
      item.refType == proxy.$ms.constant.RefType.BAWithDraw
    ) {
      delete data.accounting_object_id;
      delete data.accounting_object_code;
      delete data.accounting_object_name;
      delete data.accounting_object_address;
    }
    // Từ Phiếu chi sang Thu tiền gửi
    if (proxy.refType == proxy.$ms.constant.RefType.CAPayment && item.refType == proxy.$ms.constant.RefType.BADeposit) {
      delete data.accounting_object_id;
      delete data.accounting_object_code;
      delete data.accounting_object_name;
      delete data.accounting_object_address;
    }

    // Từ chi tiền gửi sang ckkb vào tiền gửi hoặc ngược lại
    if (
      (proxy.refType == proxy.$ms.constant.RefType.BAWithDraw &&
        item.refType == proxy.$ms.constant.RefType.BUTransferDeposit) ||
      (proxy.refType == proxy.$ms.constant.RefType.BUTransferDeposit &&
        item.refType == proxy.$ms.constant.RefType.BAWithDraw)
    ) {
      [data.bank_account, data.accounting_object_bank_account] = [
        data.accounting_object_bank_account,
        data.bank_account,
      ];
      [data.bank_name, data.accounting_object_bank_name] = [data.accounting_object_bank_name, data.bank_name];
    }

    // Từ ckkb vào tiền gửi sang chi tiền gửi
    if (
      proxy.refType == proxy.$ms.constant.RefType.BUTransferDeposit &&
      item.refType == proxy.$ms.constant.RefType.BAWithDraw
    ) {
      delete data.accounting_object_code;
      delete data.accounting_object_name;
    }
    // Từ Chuyển tiền nội bộ sang chi tiền gửi
    if (
      proxy.refType == proxy.$ms.constant.RefType.BABankTransfer &&
      item.refType == proxy.$ms.constant.RefType.BAWithDraw
    ) {
      delete data.accounting_object_id;
      delete data.accounting_object_code;
      delete data.accounting_object_name;
      delete data.accounting_object_address;
      data.bank_account =  data[detailGrid].find(item =>  item.from_bank_account !== undefined).from_bank_account; 
      data.bank_name = proxy.$store.getters[`${ModuleBankInfo}/items`].find(
        x => x.bank_account == data.bank_account 
      )?.bank_name;
    }
    // Gán details
    (data[detailGrid] || []).forEach(element => {
      element.accounting_object_id = element.accounting_object_id || element.debit_accounting_object_id;
      element.accounting_object_code = element.accounting_object_code || element.debit_accounting_object_code;
      element.accounting_object_name = element.accounting_object_name || element.debit_accounting_object_name;
      element.debit_accounting_object_id = element.debit_accounting_object_id || element.accounting_object_id;
      element.debit_accounting_object_code = element.debit_accounting_object_code || element.accounting_object_code;
      element.debit_accounting_object_name = element.debit_accounting_object_name || element.accounting_object_name;

      element.budget_chapter_code = element.budget_chapter_code || proxy.dbOptions.DefaultBudgetChapterCode;
      element.budget_source_id = element.budget_source_id || proxy.dbOptions.DefaultBudgetSourceID;
      element.budget_source_name = element.budget_source_name || proxy.dbOptions.DefaultBudgetSourceName;
      element.budget_kind_item_code = element.budget_kind_item_code || proxy.dbOptions.DefaultBudgetKindItemCode;
      element.budget_sub_kind_item_code =
        element.budget_sub_kind_item_code || proxy.dbOptions.DefaultBudgetSubKindItemCode;

      // Nếu sinh chứng từ từ Rút dự toán tiền mặt => bỏ thông tin NH,KB
      if (
        proxy.refType == proxy.$ms.constant.RefType.BUPlanWithdrawCash ||
        proxy.refType == proxy.$ms.constant.RefType.BUPlanWithdrawTransfer ||
        proxy.refType == proxy.$ms.constant.RefType.BUPlanWithdrawDeposit
      ) {
        element.bank_account = null;
        element.bank_name = null;
      }

      // Nếu sinh chứng từ từ Thu tiền gửi => Chuyển tiền nội bộ
      if (
        proxy.refType == proxy.$ms.constant.RefType.BADeposit && 
        item.refType == proxy.$ms.constant.RefType.BABankTransfer
      ) {
        element.from_bank_account = data.accounting_object_bank_account;
        element.credit_account = element.debit_account;
      }
      
      if (
        (proxy.refType == proxy.$ms.constant.RefType.BADeposit &&
          item.refType == proxy.$ms.constant.RefType.BUTransfer) || // Từ Thu tiền gửi sang CKKB
        (proxy.refType == proxy.$ms.constant.RefType.BADeposit &&
          item.refType == proxy.$ms.constant.RefType.CAPayment) || // Từ Thu tiền gửi sang phiếu chi
        (proxy.refType == proxy.$ms.constant.RefType.BADeposit &&
          item.refType == proxy.$ms.constant.RefType.GLGeneralVoucher) || // Từ Thu tiền gửi sang CTNVK
        (proxy.refType == proxy.$ms.constant.RefType.BUTransfer &&
          item.refType == proxy.$ms.constant.RefType.BADeposit) || // Từ CKKB sang Thu tiền gửi
        (proxy.refType == proxy.$ms.constant.RefType.CAReceipt &&
          item.refType == proxy.$ms.constant.RefType.BAWithDraw) || // Từ Phiếu thu sang Chi tiền gửi
        (proxy.refType == proxy.$ms.constant.RefType.BAWithDraw &&
          item.refType == proxy.$ms.constant.RefType.CAPayment) || // Từ Chi tiền gửi sang Phiếu chi
        (proxy.refType == proxy.$ms.constant.RefType.BAWithDraw &&
          item.refType == proxy.$ms.constant.RefType.GLGeneralVoucher) || // Từ Chi tiền gửi sang
        (proxy.refType == proxy.$ms.constant.RefType.CAPayment && item.refType == proxy.$ms.constant.RefType.BADeposit) // Từ phiếu chi sang Thu tiền gửi
      ) {
        element.accounting_object_id = null;
        element.accounting_object_code = null;
        element.accounting_object_name = null;
        element.debit_accounting_object_id = null;
        element.debit_accounting_object_code = null;
        element.debit_accounting_object_name = null;
      }
    });

    switch (item.refType) {
      case proxy.$ms.constant.RefType.CAPayment:
      case proxy.$ms.constant.RefType.BUTransfer:
      case proxy.$ms.constant.RefType.BAWithDraw:
      case proxy.$ms.constant.RefType.BUTransferDeposit:
        if (detailGrid != 'Detail') {
          data.Detail = data[detailGrid];
          delete data[detailGrid];
        }
        break;

      case proxy.$ms.constant.RefType.CAReceiptPlanWithdraw:
      case proxy.$ms.constant.RefType.CAReceipt:
        if (detailGrid != 'CAReceiptDetail') {
          data.CAReceiptDetail = data[detailGrid];
          delete data[detailGrid];
        }
        break;

      case proxy.$ms.constant.RefType.BADeposit:
        if (detailGrid != 'BaDepositDetail') {
          data.BaDepositDetail = data[detailGrid];
          delete data[detailGrid];
        }
        break;

      case proxy.$ms.constant.RefType.GLGeneralVoucher:
        if (detailGrid != 'GLVoucherDetails') {
          data.GLVoucherDetails = data[detailGrid];
          delete data[detailGrid];
        }
        break;
      case proxy.$ms.constant.RefType.BABankTransfer:
        if (detailGrid != 'BABankTransferDetail') {
          data.BABankTransferDetail = data[detailGrid];
          delete data[detailGrid];
        }
        break;
      case proxy.$ms.constant.RefType.BUPlanWithdrawDeposit:
      case proxy.$ms.constant.RefType.BUPlanWithdrawCash:
      case proxy.$ms.constant.RefType.BUPlanWithdrawTransfer:
      case proxy.$ms.constant.RefType.BUPlanWithdrawSalaryTransfer:
        break;
    }
    return data;
  };
  /**
   * Cập nhật dữ liệu detail - phần xử lý chung
   * @param {*} keyMaster
   * @param {*} data
   * @returns
   */
  const changeKeyDetail = (key, data) => {
    if (data?.length > 0) {
      data.forEach(element => {
        element.ref_id = key;
        element.ref_detail_id = proxy.$ms.commonFn.generateUUID();
        if (element['is_treasury_approved']) {
          element['is_treasury_approved'] = false;
        }
        if (element['withdraw_ref_detail_id']) {
          element['withdraw_ref_detail_id'] = null;
        }
        element['state'] = proxy.$ms.constant.ModelState.Insert;
      });
    }
    return data;
  };

  /**
   *  Cập nhật dũ liệu detail khi offline
   * @param {*} key
   * @param {*} data
   * @returns
   */
  const updateKeyForDetailDataWhenOffline = (key, data) => {
    let detailKeys = [];
    switch (data.ref_type) {
      case proxy.$ms.constant.RefType.BUTransferDeposit:
        detailKeys = [
          'Detail',
          'DetailPurchase',
          'Parallels',
          'DetailSalary',
          'DetailFixedAsset',
          'DetailFixedAssetFA',
        ];
        break;
      default:
        break;
    }
    if (detailKeys.length > 0) {
      detailKeys.forEach(element => {
        data[element] = changeKeyDetail(key, data[element]);
      });
    }
    return data;
  };

  /**
   * Gen code với TH thêm duplicate
   * @param {*} code
   * @returns
   */
  const processSuffixRightToLeft = code => {
    var position = 0;
    var isEndSuffix = false;
    var isEndValue = false;
    var strPrefix = '';
    var strValue = '';
    var strSuffix = '';
    while (position <= code.length - 1) {
      var strChar = code.substring(code.length - 1 - position, code.length - position);
      let tempChar = Number.parseInt(strChar);
      if (isEndSuffix == false && !isNaN(tempChar)) {
        strSuffix = strChar + strSuffix;
      } else {
        isEndSuffix = true;
        if (isEndValue == false && isNaN(tempChar)) {
          strValue = strChar + strValue;
        } else {
          isEndValue = true;
          strPrefix = strChar + strPrefix;
        }
      }
      position += 1;
    }
    var iValue = isNaN(Number.parseInt(strSuffix)) ? 0 : Number.parseInt(strSuffix);
    return `${strValue}${iValue + 1}`;
  };

  /**
   * Lấy dữ liệu nhân bảng khi offline
   * @returns
   */
  const getDuplicateDataOffline = async () => {
    var data = _.cloneDeep(proxy.model);
    data.ref_id = proxy.$ms.commonFn.generateUUID();
    data.state = proxy.$ms.constant.ModelState.Duplicate;
    data.withdraw_ref_date = null;
    data.withdraw_ref_id = null;
    data.withdraw_ref_no = null;
    data.VoucherReferences = [];
    data.is_posted = false;
    data.is_dvc_voucher = false;
    const indexDb = new indexedDB();
    // tăng số CT
    let dataQueue = await indexDb.get('cache_dataOffline');
    if (dataQueue.length > 0 && dataQueue.some(x => x.ref_type == data.ref_type)) {
      dataQueue = dataQueue.filter(x => x.ref_type == data.ref_type);
      let lastItem = dataQueue[dataQueue.length - 1];
      if (lastItem) {
        data.ref_no = processSuffixRightToLeft(lastItem.ref_no);
      }
    } else {
      data.ref_no = processSuffixRightToLeft(data.ref_no);
    }
    // cập lại ref_id cho các dữ liệu detail
    data = updateKeyForDetailDataWhenOffline(data.ref_id, data);
    return data;
  };

  /**
   * Thực hiện copy voucher
   * @param {*} item
   */
  const clickItemCopyVoucher = async item => {
    if (item.form && item.refType) {
      let param = {
        data: proxy.model,
        mode: proxy.$ms.constant.FormState.Copy,
        id: proxy.model[proxy.$store.state[proxy.module]._config.field.key],
      };

      var data;
      if (!offlineReady.value) {
        data = await proxy.$store.dispatch(`${proxy.module}/get`, {
          action: 'Duplicate',
          id: param.id,
          param: JSON.stringify({
            RefTypeKey: item.refType,
            UseRefNo: proxy.model.ref_type === item.refType ? true : false,
          }),
        });
      } else {
        data = await getDuplicateDataOffline();
      }

      data = customVoucherData(data, item);
      param.data = data;

      popupUtil.show(item.form, param);
    }
  };

  return {
    clickItemCopyVoucher
  };
};